import { Injectable } from '@angular/core';
import { Payable } from "../../interface/payable/payable";
import { HttpService } from "../http/http.service";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PayableService {


  constructor(private _payableService: HttpService) { }

  public async getPayableList(): Promise<any> {
    return await firstValueFrom(this._payableService.get('/PurchaseInvoices/payments?number=1&size=999999'));
  }
  sendPayableRecord(data: Payable): Promise<any> {
    return this._payableService.post('/PurchaseInvoices/payments', data).toPromise();
  }
  updatePayableRecord(data: Payable): Promise<any> {
    return (this._payableService.post('/PurchaseInvoices/payments', data)).toPromise();
  }
  deletePayableRecord(id: number) {
    return this._payableService.delete('/PurchaseInvoices/payments/', id);
  }
}

